import { useOnboardingProgress } from "../../workflows/api/useOnboardingProgress";
import { sqprStillImporting } from "../sqprSettlement";

/** SQPR importing state + percent. Shares the banner's queries (react-query
 * dedupes by key), so mounting this elsewhere adds no polling. */
export const useSqprIngestionStatus = (): { importing: boolean; percent: number | null } => {
  const { backfill } = useOnboardingProgress();

  const sqpr = backfill.data?.sqpr_progress ?? null;
  const importing = sqprStillImporting(sqpr, backfill.data?.sqpr_dispatched_at);
  const percent = sqpr && sqpr[1] > 0 ? Math.min(100, Math.max(0, Math.round((sqpr[0] / sqpr[1]) * 100))) : null;

  return { importing, percent };
};
